import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {}

  settasks() {
    const id = event.target.value
    fetch(`/employees/${id}/employee_tasks`)
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP error: ${response.status}`)
        return response.json()
      })
      .then((data) => {
        this.setDropdown(data)
      })
      .catch((error) => {
        console.error("Failed to fetch employee tasks:", error)
      })
  }

  setDropdown(data) {
    const dropdown = document.getElementById("time_sheet_task_ids")
    dropdown.innerHTML = "" //clear previous options

    data.forEach((item) => {
      const option = document.createElement("option")
      option.value = item.id
      option.text = item.name
      dropdown.appendChild(option)
    })
  }

  hide_payments_table() {
    const elements = document.getElementsByClassName("payment-table")
    Array.from(elements).forEach((ele) => {
      if (ele.classList.contains("hidden")) {
        ele.classList.remove("hidden")
      } else {
        ele.classList.add("hidden")
      }
    })
  }
}
